module.exports = __webpack_public_path__ + "static/media/maxSuccessionWins_30_40.0cddb750.png";